<template>
    <navroot ptype="person" />
    <div class="scroll-box person-center">
        <div class="person-info" v-if="user" :style="{ backgroundImage: 'url(' + pageContent?.banner_image + ')' }">
            <i class="avatar" :style="{ backgroundImage: 'url(' + user.HeadPhotoPath + ')' }"></i>
            <div class="name">{{ user.NickName || user.Name }}</div>
            <div class="button-content">
                <a-button class="button-item" :class="{ selected: menu == item.type }" @click="chooseMenu(item.type)"
                    v-for="item in menuList">{{ item.title }}</a-button>
            </div>
        </div>
        <div class="person-content">
            <person-info v-if="menu == 'person'"></person-info>
            <achievement-list v-if="menu == 'achievement'"></achievement-list>
            <certificat-list v-if="menu == 'certificat'"></certificat-list>
        </div>
    </div>
</template>

<script>
import navroot from '../nav/nav.vue';
import personInfo from './person-info/person-info.vue';
import achievementList from '../achievement/achievement-list/achievement-list.vue';
import certificatList from '../achievement/certificat-list/certificat-list.vue';

export default {
    name: "person_center",
    components: {
        navroot, personInfo, achievementList, certificatList
    },
    data() {
        return {
            user: {},
            menuList: [
                { title: '个人信息', type: 'person' },
                { title: '徽章', type: 'achievement' },
                { title: '证书', type: 'certificat' },
            ],
            menu: 'person',
            pageContent: '',
            theme_color: ''
        };
    },

    async mounted() {
        this.$store.commit('currentClass', null);

        let user = this.$store.state.userInfo;
        if (!user) return;
        this.user = user;

        let { platform } = this.$store.state;
        this.pageContent = platform.page_content['person_center'];
        this.theme_color = platform.pageConfig.theme_color;
    },
    methods: {
        onSubmit() {
            this.$refs.ruleForm.validate()
                .then(() => {
                    this.$nzconfirm("是否确认修改信息！", () => {
                        this.updateUser();
                    })
                })
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        //修改用户信息
        async updateUser() {
            let newUser = this.newUser;
            const params = {
                PK_UserGuid: this.user.PK_UserGuid,             // 用户guid(必传)
                ...newUser
            }
            let res = await this.$api.unifydata.updateStudent(params);
            this.logining = false;
            if (res.statusCode != 200) return this.$message.warning(res.msg);
            this.$message.success("修改成功！");
        },
        //搜索学校
        async handleSearch(val) {
            if (!val || this.fetching) return;
            this.fetching = true;
            let orgList = await this.$api.unifydata.searchOrg({ keyWord: val }).then(res => res.data);
            orgList.forEach(item => {
                item.value = item.PK_OrgGuid;
                item.label = item.Name;
            });
            setTimeout(() => { this.fetching = false; }, 300);
            this.orgList = orgList;
        },
        //选择学校
        handleChange(val) {
            let org = this.orgList.find(item => item.PK_OrgGuid == val);
            this.newUser.FK_OrgGuid = val;
            this.newUser.School = org.Name;
        },
        //选择菜单
        chooseMenu(type) {
            this.menu = type;
            $('.scroll-box').animate({ scrollTop: 0 }, 300);
        }
    },
}

</script>

<style scoped lang="scss">
@import './person-center.scss';
</style>
